export const toast = (message, type = 'success', duration = 3500) => {
  window.dispatchEvent(
    new CustomEvent('esave-toast', { detail: { message, type, duration, id: Date.now() } })
  );
};
